import React, { Suspense, lazy } from 'react';
import { BookPromo } from './components/BookPromo';
// Lazy load the SalesPopup component since it's not critical for initial render
const SalesPopup = lazy(() => import('./components/SalesPopup').then(module => ({
  default: module.SalesPopup
})));
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <BookPromo data-id="element-1" />
      <Suspense fallback={null} data-id="element-2">
        <SalesPopup data-id="element-3" />
      </Suspense>
    </div>;
}